import { render, staticRenderFns } from "./EzBadge.vue?vue&type=template&id=17ff431a&scoped=true&"
import script from "./EzBadge.vue?vue&type=script&lang=js&"
export * from "./EzBadge.vue?vue&type=script&lang=js&"
import style0 from "./EzBadge.vue?vue&type=style&index=0&id=17ff431a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ff431a",
  null
  
)

export default component.exports